export function calculateDistance(
  position1: { lat: number; lon: number },
  position2: { lat: number; lon: number },
) {
  const latDiff = position1.lat - position2.lat;
  const lonDiff = position1.lon - position2.lon;
  return Math.sqrt(latDiff * latDiff + lonDiff * lonDiff);
}
